import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const Options = ({
	onChange,
	options,
	label,
	value,
	name,
	required = false,
}) => {
	return (
		<FormControl fullWidth sx={{ marginBottom: 2 }}>
			<InputLabel id={`select-label-${name}`}>{label}</InputLabel>
			<Select
				labelId={`select-label-${name}`}
				id={`select-${name}`}
				value={value}
				label={label}
				name={name}
				onChange={onChange}
				required={required}
			>

				{(options || []).map(({ value, label }) => {
					return (
						<MenuItem key={value} value={value}>
							{label}
						</MenuItem>
					);
				})}
			</Select>
		</FormControl >
	);
};



Options.type = 'Options';
Options.spec = [{
	name: 'Options',
	key: 'Options',
	title: 'Options',
	icon: 'List',
	category: 'input',
	translatable: ['label', 'options'],
	fields: [{
		type: 'TextField',
		label: 'Label',
		name: 'label',
	}, {
		type: 'Checkbox',
		label: 'Required?',
		name: 'required',
	}, {
		type: 'repeater',
		label: 'Radio Options',
		name: 'options',
		fields: [{
			type: 'TextField',
			name: 'label',
			label: 'option label',
		}, {
			type: 'TextField',
			name: 'value',
			label: 'option value',
		}],
	}],
}];

export default Options;